import { render, staticRenderFns } from "./apiCardList.vue?vue&type=template&id=52f20fc5&"
import script from "./apiCardList.vue?vue&type=script&lang=js&"
export * from "./apiCardList.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports